import {Component, OnInit, Input, ElementRef, HostListener, Output, EventEmitter} from '@angular/core';
import {isNullOrUndefined} from "util";
import {I18nPipe} from "../../i18n/i18n.pipe";

declare var $: any;

@Component({
    selector: 'o-duallistbox',
    template: `
     <select [name]="name" multiple class="smart-duallistbox">
        <option *ngFor="let item of items" [selected]="item.selected" [value]="item.key" >{{item.value}}</option>
      </select>
  `,
    styles: []
})
export class OriginalDuallistboxComponent implements OnInit {

    @Input() items: Array<any>;
    @Output() itemsChange = new EventEmitter();
    @Input() selected: Array<any> = [];

    @Input() nonSelectedFilter: any;
    @Input() nonSelectedListLabel: string = this.i18n.transform('Non-selected');
    @Input() selectedListLabel: string = this.i18n.transform('Selected');
    @Input() preserveSelectionOnMove: string = this.i18n.transform('moved');
    @Input() moveOnSelect: boolean = false;
    @Input() size: number = 10;
    @Input() name: string = Date.now().toString().slice(-5);

    @HostListener('click') onClick(){
        let selected = this.element.find('.smart-duallistbox').val() || [];

        if (
            selected.some(it=>this.selected.indexOf(it) == -1)
            ||
            this.selected.some(it=>selected.indexOf(it) == -1)
        ){
            this.selected = selected;

            this.items.forEach((item)=>{
                if(this.selected.indexOf(item.key) > -1){
                    item.selected = true
                } else {
                    delete item.selected
                }
            });

            this.itemsChange.emit(this.items);
        }

    }

    public element: any;

    constructor(private el: ElementRef,
                private i18n: I18nPipe) {
        this.element = $(this.el.nativeElement);
    }

    ngOnInit() {
        this.selected = this.items.filter((item)=>item.selected).map(item=>item.key);

        if (!!this.i18n.i18nService.data)
            this.render();
        else {
            this.i18n.i18nService.subscribe(() => {
                this.nonSelectedListLabel = this.i18n.transform('Non-selected');
                this.selectedListLabel = this.i18n.transform('Selected');
                this.preserveSelectionOnMove = this.i18n.transform('moved');
                this.render();
            }, () => this.render());
        }
    }

    render() {
        System.import('script-loader!bootstrap4-duallistbox/dist/jquery.bootstrap-duallistbox.min.js').then(() => {
            let options = {
                nonSelectedFilter: this.nonSelectedFilter,
                nonSelectedListLabel: this.nonSelectedListLabel,
                selectedListLabel: this.selectedListLabel,
                preserveSelectionOnMove: this.preserveSelectionOnMove,
                moveOnSelect: this.moveOnSelect,
                size: this.size
            };
            this.element.bootstrapDualListbox(options);
            this.element.find('input').each((index, input) => input.placeholder = this.i18n.transform(input.placeholder));
            this.element.find('.smart-duallistbox').change(() => this.onClick());
            this.element.find('button').addClass('asigno-icon-down-arrow boton-modal-select');
            this.element.find('select').addClass('nio-scrollbar-gray');
        });
    }

}

export class DuallistboxOption {
    key: string;
    value: string;
    selected: boolean = false;

    constructor()
    constructor(key: string, value: string)
    constructor(key: string, value: string, selected: boolean)
    constructor(key?: string, value?: string, selected?: boolean) {
        if (key) this.key = key;
        if (value) this.value = value;
        if (!isNullOrUndefined(selected)) this.selected = selected;
    }
}
